<template>
  <!--pages/order/index.wxml-->
  <div class="order-page" v-scroll-bottom="loadMoreData">
      <div class="order-wrap">
          <div class="filter-wrap">
              <div class="search-wrap">
                  <!-- <icon class="search-icon" type="search" size="25"></icon> -->
                  <input type="search" v-model="search" class="search-input" placeholder="请输入订单号" />
                  <span @click="searchOrder" style="" class="order-search-btn">搜索</span>
              </div>
              <!-- <button class="search-btn full-btn orange-btn" bindtap="searchOrder" size="mini">搜索</button> -->
          </div>
          <filter-widget :filter-list="filterList" @change="onFilter"></filter-widget>
          <div class="order-list-wrap">
              <!-- 引入 order list 组件 -->
              <order-list mode="order" :order-list="orderList" :has-more="hasMore"></order-list>
          </div>
      </div>
  </div>
</template>
<script>
import FilterWidget from '@/components/filter/FilterWidget.vue';
import OrderList from '@/components/list/OrderList.vue';
import { getOrderList } from '@/helpers/orderHelper';

// getOrderList
export default {
  components: {
    FilterWidget,
    OrderList
  },
  data() {
    return {
        orderList: [],
        page: 1,
        hasMore: false,
        search: '',
        status: 0,
        filterList: [{
            id: '1',
            value: '0',
            text: '全部'
        }, {
            id: '2',
            value: '15',
            text: '待付款'
        }, {
            id: '3',
            value: '16',
            text: '已付款'
        }, {
            id: 5,
            value: 17,
            text: '已完成'
        }, {
            id: '4',
            value: '-2',
            text: '其他'
        }]
    }
  },
  created() {
    getOrderList(this)
  },
  methods: {
    searchOrder() {
      this.page = 1
      this.hasMore = false
      this.orderList = []
      getOrderList(this)
    },
    loadMoreData() {
      if (this.hasMore) {
        this.page++
        getOrderList(this)
      }
    },
    onFilter(e) {
        this.status = e
        this.orderList = []
        this.page = 1
        getOrderList( this )
    }
  }
}
</script>
<style scoped>
/* pages/order/index.wxss */
.order-page {
    background-color: rgba(0, 0, 0, 0.05);
    min-height: var(--len900);
    box-sizing: border-box;
}

.order-wrap {
    padding: var(--len20);
    
}

.search-wrap {
    position: relative;
    /* display: flex; */
    align-items: center;
}
.order-search-btn{
    position: absolute;
    right: var(--len16);
    top: var(--len5);
    z-index: 999;
    font-size: var(--len14);
}
.orange-btn{
    border-radius: var(--len30);
    height: var(--len25);
    line-height: var(--len25);
    color: white;
    font-size: var(--len12);
    display: inline-block;
    width: var(--len50);
    text-align: center;
}
.search-input {
    width: 100%;
    height: var(--len30);
    background-color: white;
    border-radius: var(--len30);
    border:0.5px solid var(--primary-color);
    box-sizing: border-box;
    padding-left: var(--len16);
    font-size: var(--len12);
}

.search-icon {
    position: absolute;
    top: var(--len3);
    left: var(--len10);
    color: lightgray;
}

.search-btn {
    margin-top: var(--len10);
    color: white;
}

.order-list {
    margin-top: var(--len10);
}

.order-item::before {
    top: 0;
    right: 0;
    position: absolute;
    content: '';
    border-width: var(--len16) var(--len16) var(--len16) var(--len16);
    border-color: white white transparent transparent;
    border-style: solid;
    z-index: 9;
}

.order-item::after {
    top: 0;
    right: 0;
    position: absolute;
    content: '';
    border-width: var(--len35) var(--len35) var(--len35) var(--len35);
    border-color: #409EFF #409EFF transparent transparent;
    border-style: solid;
}

.order-status {
    position: absolute;
    top: 0;
    right: 0px;
    transform: rotate(45deg);
    z-index: 99;
    color: white;
    overflow: hidden;
    line-height: var(--len30);
    width: var(--len100);
    height: var(--len100);
    text-align: center;
    font-size: var(--len12);
}

.order-item {
    padding: var(--len10);
    margin-bottom: var(--len10);
    background-color: white;
    box-sizing: border-box;
    position: relative;
}

.order-item-head {
    padding: var(--len10) 0 var(--len10) 0;
    font-size: var(--len12);
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
}

.order-item-content {
    padding: var(--len10) 0;
    display: flex;
}

.order-item-main {
    display: flex;
}

.order-item-left {
    width: var(--len80);
    height: var(--len80);
    overflow: hidden;
    margin-right: var(--len10);
}

.order-item-left image {
    width: var(--len80);
    height: var(--len80);
}

.order-item-right {
    flex: 1;
}

.order-item-footer {
    padding-bottom: var(--len10);
    display: flex;
}

.order-item-footer-left,
.order-item-footer-mid,
.order-item-footer-right {
    flex: 1;
    text-align: center;
}

.order-plus {
    color: white;
    background-color: var(--primary-color);
    width: var(--len50);
    height: 16px;
    line-height: var(--len16);
    margin-left: var(--len5);
    border-radius: var(--len3);
    padding: 0 var(--len3);
}

.order-item-right .order-item-title {
    font-size: var(--len16);
    line-height: var(--len25);
    font-weight: bold;
    height: var(--len50);
    overflow: hidden;
}

.order-item-right .order-item-rate {
    font-size: var(--len14);
    height: var(--len30);
    line-height: var(--len30);
}

.order-item-rate {
    display: flex;
}

.rate-wrap {
    flex: 1;
}

.rate-label {
    font-size: var(--len14);
    color: rgba(0, 0, 0, 0.7);
}

.rate {
    margin-left: var(--len10);
    font-size: var(--len14);
    color: black;
}

.footer-label {
    color: #cccccc;
    font-size: var(--len16);
    text-align: center;
}

.load-more {
    text-align: center;
    color: #cccccc;
}
</style>